import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../assets/norsteer-logo-dark.png";
import favicon from "../assets/favicon.png";
import logoutIcon from "../assets/logout.svg";
import { useAuth } from "../context/AuthContext";
import sideMenuConfig from "../utils/dynamic_sidemenu";

export default function Sidebar({ isOpen = false, onClose = () => { }, isCollapsed = false, onToggleCollapse = () => { } }) {
  const { logout, user } = useAuth();
  const [menuItems, setMenuItems] = useState(sideMenuConfig.default);

  useEffect(() => {
    const shortcode = localStorage.getItem("shortcode"); // "tec" | "the" | "eva"

    // fallback key
    const DEFAULT_MENU = "default";
    const selectedMenu =
      shortcode && sideMenuConfig[shortcode]
        ? sideMenuConfig[shortcode]
        : sideMenuConfig[DEFAULT_MENU];
    setMenuItems(selectedMenu);
  }, []);

  return (
    <aside className={`sidebar ${isOpen ? "show" : ""} ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header d-flex align-items-center justify-content-between">
        <Link to="/pages" className="logo" style={{ textDecoration: "none", display: isCollapsed ? "none" : "flex", alignItems: "center" }}>
          <img
            src={logo}
            alt="Norsteer"
            className="logo-icon"
            style={{ maxHeight: "52px", width: "auto", maxWidth: "175px", objectFit: "contain", display: "block" }}
          />
        </Link>
        {isCollapsed && (
          <Link to="/pages" className="logo-collapsed" style={{ textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
            <img
              src={favicon}
              alt="Norsteer"
              style={{ maxHeight: "36px", width: "36px", objectFit: "contain", display: "block" }}
            />
          </Link>
        )}

        {/* Collapsible toggle for Desktop */}
        <button
          type="button"
          className="btn d-none d-lg-flex p-1 border-0 bg-transparent text-secondary align-items-center justify-content-center"
          onClick={onToggleCollapse}
          title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
          style={{ cursor: "pointer", outline: "none", marginLeft: isCollapsed ? "0" : "0", marginRight: isCollapsed ? "auto" : "0" }}
        >
          {isCollapsed ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0D0D12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="18" x="3" y="3" rx="2" />
              <path d="M9 3v18" />
              <path d="m14 9 3 3-3 3" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0D0D12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="18" x="3" y="3" rx="2" />
              <path d="M9 3v18" />
              <path d="m16 15-3-3 3-3" />
            </svg>
          )}
        </button>

        {/* optional close button visible only on mobile */}
        <button className="btn close-sidebar d-mobile-only ms-auto" onClick={onClose}>
          ✕
        </button>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item, idx) => (
          <div key={idx} className="menu-item">
            <NavLink
              to={item.path}
              title={isCollapsed ? item.label : ""}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? "active" : ""}`
              }
            >
              <span className="navicon">
                <img src={item.icon} alt="" />
              </span>
              {!isCollapsed && item.label}
            </NavLink>
          </div>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="logout-nav">
          {!isCollapsed && (
            <div className="userdtl">
              <div className="usertitle">{user?.name || ""}</div>
              <div className="useremail">{user?.email || ""}</div>
            </div>
          )}
          <button onClick={logout} title={isCollapsed ? "Logout" : ""} style={{ marginLeft: isCollapsed ? "auto" : "0", marginRight: isCollapsed ? "auto" : "0", background: "none", border: "none", padding: 0 }}>
            <img src={logoutIcon} alt="Logout" />
          </button>
        </div>
      </div>
    </aside>
  );
}
